query TripTravelPlans($first: Int, $after: Cursor) {
  tripTravelPlans(
    orderBy: [TRAVEL_AUTHORIZATION_NUMBER_DESC, PRIMARY_KEY_ASC]
    first: $first
    after: $after
  ) {
    nodes {
      id
      travelAuthorizationNumber
      travelPlan
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
